/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2025-01-19 10:57:25
 **/
/* eslint-disable @typescript-eslint/no-explicit-any */

import Heap from "./Heap";

export default class PriorityQueue<T = any> extends Heap<T> {
	constructor() {
		super();
	}

	/**
	 * Adds an element to the priority queue with the specified priority.
	 *
	 * @param {number} priority - The priority of the element to be enqueued. Lower values indicate higher priority.
	 * @param {T} value - The value to be enqueued.
	 * @return {void}
	 */
	public enqueue(priority: number, value: T): void {
		this.insert(priority, value);
	}

	/**
	 * Removes and returns the element at the front of the queue.
	 * The front of the queue is the element that was added first.
	 * If the queue is empty, it may return undefined or throw an error based on implementation.
	 *
	 * @return {*} The element removed from the front of the queue.
	 */
	public dequeue() {
		return this.remove();
	}

	/**
	 * Checks if the heap is empty.
	 *
	 * @return {boolean} True if the heap is empty, false otherwise.
	 */
	public get is_empty(): boolean {
		return this._heap.length <= 0;
	}
}
